export default __webpack_public_path__ + "static/media/gallery4.25ce1647.jpg";